// extracted by mini-css-extract-plugin
export default {"dialog-footer":"DialogFooter_dialog-footer__FqE9r"};